import React from "react"
import { Box, Typography, LinearProgress, Chip, Stack } from "@mui/material"
import PublicIcon from "@mui/icons-material/Public"
import FlagIcon from "@mui/icons-material/Flag"

const TOTAL_US_STATES = 50
const TOTAL_COUNTRIES = 195

const TravelStats = ({ visitedUsa = [], visitedWorld = [] }) => {
  const stateCount = visitedUsa.length
  const statePct = Math.round((stateCount / TOTAL_US_STATES) * 100)
  const countryCount = visitedWorld.length
  const countryPct = Math.round((countryCount / TOTAL_COUNTRIES) * 100)

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      sx={{ px: 2, py: 1, alignItems: "center" }}
    >
      <Box sx={{ flex: 1, minWidth: 180 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
          <FlagIcon fontSize="small" color="primary" />
          <Typography variant="body2" fontWeight={600}>
            {stateCount}/{TOTAL_US_STATES} states
          </Typography>
          <Chip label={`${statePct}%`} size="small" color="primary" variant="outlined" />
        </Stack>
        <LinearProgress
          variant="determinate"
          value={statePct}
          sx={{ height: 6, borderRadius: 3 }}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 180 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
          <PublicIcon fontSize="small" color="secondary" />
          <Typography variant="body2" fontWeight={600}>
            {countryCount} countries
          </Typography>
          <Chip label={`${countryPct}%`} size="small" color="secondary" variant="outlined" />
        </Stack>
        <LinearProgress
          variant="determinate"
          value={countryPct}
          color="secondary"
          sx={{ height: 6, borderRadius: 3 }}
        />
      </Box>
    </Stack>
  )
}

export default TravelStats
